import { useRef } from 'react';
import { NotebookPenIcon, AlignLeftIcon } from 'lucide-react';
import { useNamespaceCopy } from '@/i18n/ns';
import copyCatalog from '@/i18n/ns/meeting-member-notes';

export type MeetingView = 'canvas' | 'transcript';
export function MeetingNavigation({
  id,
  view,
  onChange,
}: {
  id: string;
  view: MeetingView;
  onChange: (view: MeetingView) => void;
}) {
  const copy = useNamespaceCopy(copyCatalog);
  const root = useRef<HTMLDivElement>(null);
  return (
    <div className="ws-meeting-navigation" role="tablist" aria-label={copy.views} ref={root}>
      {(['canvas', 'transcript'] as const).map((tab) => {
        const Icon = tab === 'canvas' ? NotebookPenIcon : AlignLeftIcon;
        return (
          <button
            type="button"
            key={tab}
            role="tab"
            id={`meeting-${id}-${tab}-tab`}
            aria-selected={view === tab}
            aria-controls={`meeting-${id}-panel`}
            tabIndex={view === tab ? 0 : -1}
            onClick={() => onChange(tab)}
            onKeyDown={(event) => {
              if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
              event.preventDefault();
              const next =
                event.key === 'Home'
                  ? 'canvas'
                  : event.key === 'End'
                    ? 'transcript'
                    : tab === 'canvas'
                      ? 'transcript'
                      : 'canvas';
              onChange(next);
              root.current
                ?.querySelectorAll<HTMLButtonElement>('[role="tab"]')
                [next === 'canvas' ? 0 : 1]?.focus();
            }}
          >
            <Icon size={15} strokeWidth={1.7} aria-hidden />
            {copy[tab]}
          </button>
        );
      })}
    </div>
  );
}
